/**
 * @fileoverview POST handler for the "/companies/workspace_rate_limits/upsert" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesWorkspaceRateLimitsUpsertCacheKeys } from "./constants";
import type { PostCompaniesWorkspaceRateLimitsUpsertProps } from "./types";

export const postCompaniesWorkspaceRateLimitsUpsert = reactQueryMutationAdapter(
  companiesWorkspaceRateLimitsUpsertCacheKeys,
  (props: PostCompaniesWorkspaceRateLimitsUpsertProps): Promise<void> => {
    // manipulate props here as needed { api_type, endpoint, app_group_ids, limit, allocation_id? }

    return fetch("/companies/workspace_rate_limits/upsert", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
